var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7001 0.100098C12.7612 0.100098 12.0001 0.861214 12.0001 1.8001C12.0001 2.73898 12.7612 3.5001 13.7001 3.5001H18.0959L7.39802 14.198C6.73412 14.8619 6.73412 15.9383 7.39802 16.6022C8.06191 17.2661 9.13829 17.2661 9.80218 16.6022L20.5001 5.90426V10.3001C20.5001 11.239 21.2612 12.0001 22.2001 12.0001C23.139 12.0001 23.9001 11.239 23.9001 10.3001V1.8001C23.9001 0.861214 23.139 0.100098 22.2001 0.100098H13.7001Z",
    fill: "#4BA5AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5001 3.5001C1.62233 3.5001 0.100098 5.02233 0.100098 6.9001V20.5001C0.100098 22.3779 1.62233 23.9001 3.5001 23.9001H17.1001C18.9779 23.9001 20.5001 22.3779 20.5001 20.5001V15.4001C20.5001 14.4612 19.739 13.7001 18.8001 13.7001C17.8612 13.7001 17.1001 14.4612 17.1001 15.4001V20.5001H3.5001V6.9001L8.6001 6.9001C9.53898 6.9001 10.3001 6.13898 10.3001 5.2001C10.3001 4.26121 9.53898 3.5001 8.6001 3.5001H3.5001Z",
    fill: "#4BA5AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.8463dc65.svg";
export { ForwardRef as ReactComponent };